import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import AlertPageLayout from 'src/components/AlertPageLayout';
import { CheckOutSummary } from 'src/components/CheckOutSummary';

const useStyles: any = makeStyles((theme: any) => ({
  hr: {
    backgroundColor: theme.palette.success['500'],
    border: 0,
    height: 1,
    margin: theme.spacing(2, 0),
  },
  bottomSection: {
    textAlign: 'center',
  },
}));

type LocationState = {
  redirectUrl: string;
  isDecline?: boolean;
};

const Success = () => {
  const location = useLocation<LocationState>();
  const classes = useStyles();

  useEffect(() => {
    if (location.state.redirectUrl) {
      setTimeout(() => {
        window.location.href = location.state.redirectUrl;
      }, 3000);
    }
  }, []);

  if (location.state.isDecline) {
    return <AlertPageLayout pageTitle='Declined' subtitle='The purchase has been declined' variant='success' />;
  }

  return (
    <AlertPageLayout pageTitle='Success' subtitle='Your transaction details are below.' variant='success'>
      <hr className={classes.hr} />
      <Typography variant='h5'>Payment summary</Typography>
      <CheckOutSummary noMargin />
      {location.state.redirectUrl && (
        <>
          <hr className={classes.hr} />
          <Box className={classes.bottomSection}>
            <Typography variant='subtitle2' component='p'>
              You&apos;re now leaving Shift...
            </Typography>
            <Typography variant='subtitle1'>
              Continuing to <a href={location.state.redirectUrl}>{location.state.redirectUrl}</a>
            </Typography>
          </Box>
        </>
      )}
    </AlertPageLayout>
  );
};

export default Success;
